<template>
  <div class="border-t border-gray-300">
    <div
      class="xl:flex-row xl:px-9 lg:px-[34px] sm:px-[22px] px-[18px] my-4 max-w-screen-xl mx-auto w-full flex flex-col justify-start pt-10"
    >
      <div class="mb-10 flex flex-col items-start md:items-center xl:items-start xl:mr-36">
        <NuxtLink
          :to="$localePath('/')"
          class="flex ml-1 mb-3"
          aria-label="Перейти на главную страницу"
        >
          <IconPolkaLogo
            class="logo-duck mr-2"
          />
          <img
            class="pt-1 logo-polka"
            src="/polka.svg"
            loading="lazy"
            width="80"
            height="34"
            alt="Полка"
          />
        </NuxtLink>
        <div
          class="w-64 lg:w-75 my-4 lg:mr-6 font-medium text-gray-900 text-start md:text-center xl:text-start"
        >
          Маркетплейс для аренды вещей с безопасными сделками.
        </div>
        <div
          class="w-64 lg:w-75 text-xs text-gray-700 text-start md:text-center xl:text-start"
        >
          <div class="font-bold text-gray-900 mb-3">
            «ООО Полка Рент»
          </div>
          <div>125362, г. Москва, ул. Свободы, 17</div>
          <div class="flex items-center justify-start md:justify-center xl:justify-start gap-1.5">
            <IconPhone class="w-4 h-4 shrink-0 text-gray-500" />
            <a
              href="tel:+78007074267"
              class="text-blue-600 hover:underline"
            >8 (800) 707-42-67</a>
          </div>
          <div class="font-bold text-gray-900 mt-2">
            Самовывоз:
          </div>
          <div>Москва, Никулинская улица, 27Б</div>
          <div class="flex items-center justify-start md:justify-center xl:justify-start gap-1.5">
            <IconPhone class="w-4 h-4 shrink-0 text-gray-500" />
            <a
              href="tel:+74950066383"
              class="text-blue-600 hover:underline"
            >+7 (495) 006-63-83</a>
          </div>
          <div class="flex items-center justify-start md:justify-center xl:justify-start gap-1.5">
            <IconPhone class="w-4 h-4 shrink-0 text-gray-500" />
            <a
              href="tel:+74951152318"
              class="text-blue-600 hover:underline"
            >+7 (495) 115-23-18</a>
          </div>
          <div>Санкт-Петербург, Лиговский проспект, 137</div>
          <div class="flex items-center justify-start md:justify-center xl:justify-start gap-1.5">
            <IconPhone class="w-4 h-4 shrink-0 text-gray-500" />
            <a
              href="tel:+78124081126"
              class="text-blue-600 hover:underline"
            >+7 (812) 408-11-26</a>
          </div>
        </div>
        <div class="flex flex-row items-center mt-4">
          <RmSocialIconSecond
            class="mr-3"
            name="vk"
          />
          <RmSocialIconSecond
            class="mx-2"
            name="ok"
          />
          <RmSocialIconSecond
            class="mx-2"
            name="tiktok"
          />
          <RmSocialIconSecond
            class="mx-2"
            name="youtube"
          />
        </div>
      </div>
      <div class="flex md:flex-row flex-wrap flex-col w-full justify-between max-w-screen-lg gap-8">
        <div class="flex flex-col w-[200px] font-normal text-sm md:mb-10 items-start">
          <div class="font-bold text-base mb-6 text-[#515356] leading-[17px]">
            {{ $t('footer.links.about') }}
          </div>
          <a
            href="https://blog.polka.rent"
            class="mt-2 mb-1 text-gray-500 font-bold"
            target="_blank"
          >
            {{ $t('footer.links.blog') }}
          </a>
          <NuxtLink
            :to="$localePath('/contacts')"
            class="mt-2 mb-1 text-gray-500 font-bold"
          >
            {{ $t('footer.links.contact') }}
          </NuxtLink>
          <NuxtLink
            :to="$localePath('/about')"
            class="mt-2 mb-1 text-gray-500 font-bold"
          >
            {{ $t('footer.links.who_we_are') }}
          </NuxtLink>
          <NuxtLink
            :to="$localePath('/reviews')"
            class="mt-2 mb-1 text-gray-500 font-bold"
          >
            {{ $t('footer.links.reviews') }}
          </NuxtLink>
          <a
            href="https://blog.polka.rent/media"
            class="mt-2 mb-1 text-gray-500 font-bold"
            target="_blank"
          >
            {{ $t('footer.links.media') }}
          </a>
          <NuxtLink
            :to="$localePath('/vacancies')"
            class="mt-2 mb-1 text-gray-500 font-bold"
          >
            {{ $t('footer.links.vacancies') }}
          </NuxtLink>
        </div>
        <hr class="md:hidden" />
        <div class="flex flex-col w-[200px] font-normal text-sm md:mb-10 items-start">
          <div class="font-bold text-base mb-6 text-[#515356] leading-[17px]">
            {{ $t('footer.links.help') }}
          </div>
          <NuxtLink
            class="mt-2 mb-1 text-gray-500 font-bold"

            :to="$localePath('/delivery')"
          >
            {{ $t('footer.links.delivery_terms') }}
          </NuxtLink>
          <NuxtLink

            class="mt-2 mb-1 text-gray-500 font-bold"
            :to="$localePath('/shablon-dogovora-arendy')"
          >
            {{ $t('footer.links.lease_agreement_template') }}
          </NuxtLink>
          <NuxtLink
            class="mt-2 mb-1 text-gray-500 font-bold"
            :to="$localePath('/bezopasnost-i-garantii')"
          >
            {{ $t('footer.links.safety_and_guarantees') }}
          </NuxtLink>
          <NuxtLink
            class="mt-2 mb-1 text-gray-500 font-bold"
            :to="$localePath('/kodeks-povedeniya')"
          >
            {{ $t('footer.links.code_of_conduct') }}
          </NuxtLink>
          <NuxtLink
            class="mt-2 mb-1 text-gray-500 font-bold"
            :to="$localePath('/privacy-policy')"
          >
            {{ $t('footer.links.privacy_policy') }}
          </NuxtLink>
          <div class="my-2 text-gray-700">
            <a
              href="mailto:help@polka.rent"
              target="_blank"
              class="font-bold !text-blue-500 mt-2 mb-1"
              @click="handleClickEmail"
            >
              help@polka.rent
            </a>
            — {{ $t('footer.support_time') }}
          </div>
        </div>
        <hr class="md:hidden" />
        <div class="flex flex-col w-[200px] font-normal text-sm md:mb-10 items-start">
          <div class="font-bold text-base mb-6 text-[#515356] leading-[17px]">
            {{ $t('footer.links.forOwners') }}
          </div>
          <NuxtLink
            class="mt-2 mb-1 text-gray-500 font-bold"
            :to="$localePath('/kak-sdat-veshchi-v-arendu')"
          >
            {{ $t('footer.links.how_to_rent_out') }}
          </NuxtLink>
          <NuxtLink
            class="mt-2 mb-1 text-gray-500 font-bold"
            :to="$localePath('/pravila-publikacii')"
          >
            {{ $t('footer.links.rules_for_publishing_ads') }}
          </NuxtLink>
          <NuxtLink
            class="mt-2 mb-1 text-gray-500 font-bold"
            :to="$localePath('/prokatnym-kompaniyam')"
          >
            {{ $t('footer.links.for_rental_companies') }}
          </NuxtLink>
        </div>
        <hr class="md:hidden" />
        <div class="flex flex-col w-[200px] font-normal text-sm md:mb-10 items-start">
          <div class="font-bold text-base mb-6 text-[#515356] leading-[17px]">
            {{ $t('footer.links.forRenters') }}
          </div>
          <NuxtLink
            class="mt-2 mb-1 text-gray-500 font-bold"
            :to="$localePath('/kak-arendovat-veshch')"
          >
            {{ $t('footer.links.how_to_rent') }}
          </NuxtLink>
        </div>
      </div>
    </div>
    <div
      class="xl:flex-row xl:px-9 lg:px-[34px] sm:px-[22px] px-[18px] my-4 max-w-screen-xl mx-auto w-full flex flex-col justify-start pt-1"
    >

      <div
        v-if="footerCities.length"
        class="border-t border-gray-200 mt-1 pt-6 w-full"
      >
        <div class="font-bold text-base text-[#515356] mb-3">
          Города
        </div>
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-x-4 gap-y-1.5">
          <NuxtLink
            v-for="city in footerCities"
            :key="city.slug"
            :to="$localePath(`/${city.slug}/catalog`)"
            class="text-blue-600 hover:underline text-sm"
          >
            {{ city.name }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconPolkaLogo from '~/assets/svg/polka-logo-ny.svg?component'
import IconPhone from '~/assets/svg/ui/phone.svg?component'
import RmSocialIconSecond from '~/components/footer/social_icon_second.vue'

export default {
  components: {
    IconPolkaLogo,
    IconPhone,
    RmSocialIconSecond,
  },
  computed: {
    footerCities () {
      const { cities } = useCities()
      const cityList = cities.value || []
      const firstSlugs = ['moscow', 'saint-petersburg']
      const first = firstSlugs.map(slug => cityList.find(c => c.slug === slug)).filter(Boolean)
      const rest = cityList.filter(c => !firstSlugs.includes(c.slug)).sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      return [...first, ...rest].slice(0, 24)
    },
  },
  methods: {
    handleClickEmail () {
      this.$tracking.logEventAmplitude('click contact', {
        'contact code': 'EMAIL',
      })
    },
  },
}
</script>
